export default (emitter) => {
  return (error) => {
    console.error(error)
    if (error.response.status === 500) {
      emitter.emit('toast', {severity: 'error', message: 'error.technical'})
    }
    return Promise.reject(error)
  }
}
